import type { SVGProps } from 'react';

const base: SVGProps<SVGSVGElement> = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export function IconMail(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <rect x="3" y="5" width="18" height="14" rx="2.5" />
      <path d="M3.5 7l8.5 6 8.5-6" />
    </svg>
  );
}
export function IconCalendar(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <rect x="3.5" y="4.5" width="17" height="16" rx="2.5" />
      <path d="M3.5 9h17M8 3v3M16 3v3" />
    </svg>
  );
}
export function IconContacts(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <circle cx="12" cy="9" r="3.2" />
      <path d="M5.5 19c.8-3.3 3.4-5 6.5-5s5.7 1.7 6.5 5" />
    </svg>
  );
}
export function IconTasks(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M4 7l2 2 3-3M4 16l2 2 3-3M12 7.5h8M12 16.5h8" />
    </svg>
  );
}
export function IconBriefcase(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <rect x="3.5" y="7.5" width="17" height="12" rx="2.5" />
      <path d="M9 7.5V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1.5M3.5 12.5h17" />
    </svg>
  );
}
export function IconSettings(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M4 7h10M18 7h2M4 17h2M10 17h10" />
      <circle cx="16" cy="7" r="2.3" />
      <circle cx="8" cy="17" r="2.3" />
    </svg>
  );
}
export function IconSearch(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M20 20l-4-4" />
    </svg>
  );
}
export function IconShare(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M7 13v5a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-5M12 15V4M8.5 7.5L12 4l3.5 3.5" />
    </svg>
  );
}
export function IconReply(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M9 7L4 12l5 5" />
      <path d="M4 12h9a7 7 0 0 1 7 7v1" />
    </svg>
  );
}
export function IconReplyAll(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M7 7l-4 5 4 5" />
      <path d="M12 7l-4 5 4 5" />
      <path d="M9 12h7a6 6 0 0 1 6 6v1" />
    </svg>
  );
}
export function IconForward(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M15 7l5 5-5 5" />
      <path d="M20 12h-9a7 7 0 0 0-7 7v1" />
    </svg>
  );
}
export function IconFlag(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M5 21V4M5 4h12l-2 4 2 4H5" />
    </svg>
  );
}
export function IconTrash(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6.5 7l1 13a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1l1-13" />
    </svg>
  );
}
export function IconImage(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <rect x="3" y="4.5" width="18" height="15" rx="2.5" />
      <circle cx="8.5" cy="9.5" r="1.7" />
      <path d="M3.5 18l5.5-5 4 3.5 3-2.5 4.5 4" />
    </svg>
  );
}
export function IconFile(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M6 3h7l5 5v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
      <path d="M13 3v5h5" />
      <path d="M8.5 13.5h7M8.5 16.5h7" />
    </svg>
  );
}
export function IconAI(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M12 3.5l1.7 4.3a4 4 0 0 0 2.5 2.5l4.3 1.7-4.3 1.7a4 4 0 0 0-2.5 2.5L12 20.5l-1.7-4.3a4 4 0 0 0-2.5-2.5L3.5 12l4.3-1.7a4 4 0 0 0 2.5-2.5L12 3.5z" />
      <path d="M19 4.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7.7-1.8z" />
    </svg>
  );
}
export function IconPaperclip(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M20 11.5l-8 8a5 5 0 0 1-7-7l8.5-8.5a3.3 3.3 0 0 1 4.7 4.7l-8.6 8.5a1.6 1.6 0 0 1-2.3-2.3l7.9-7.8" />
    </svg>
  );
}
export function IconJunk(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M6.2 6.2l11.6 11.6" />
    </svg>
  );
}
export function IconBroom(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M19.5 3.5l-7 7" />
      <path d="M10.2 9.3l4.5 4.5c.6.6.6 1.5 0 2.1l-.4.4" />
      <path d="M9.6 10l-4.9 2.2c-.7.3-.9 1.2-.3 1.8l5.6 5.6c.6.6 1.5.4 1.8-.3L14 14.4" />
      <path d="M6.5 16.5l2-2M9 19l1.5-1.5" />
    </svg>
  );
}
export function IconPin(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M9 3.5h6l-1 5.5 3 3H7l3-3-1-5.5z" />
      <path d="M12 12v8.5" />
    </svg>
  );
}
